<section class="bannerCont">
    <h1 class="displayHeadingText">Welcome to our <span>Data Products Hub!</span></h1>
    <h2>Explore data-driven products and track your report requests all in one place</h2>
    <!-- <button (click)="startTour()" style="margin-top: 16px;">Start Guided Tour</button> -->
</section>

<div class="contentCard">
    <div id="tour-productTab" class="tabSelectorCont" #highlightedTab>
        <a class="tabItem" (click)="startTour()"
            routerLink="all"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            Data Products
        </a>
        <a *ngIf="true" class="tabItem"
            routerLink="myReports"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }">
            My Reports
        </a>
    </div>
    <router-outlet></router-outlet>
</div>

<!-- <app-tour-guide [steps]="tourSteps"></app-tour-guide> -->

<!-- <div class="overlayCont" *ngIf="showTour" #overlay>
    <div class="contentCont">
        <h5>1/3 Steps</h5>
        <h2>Improved Navigation</h2>
        <p>The ‘Data Manager’ and ‘Capabilities’ sections have been merged into a single entity known as ‘Data Products’, thereby enhancing the overall user experience.</p>
    </div>
</div> -->

<!-- <footer class="footer">
    &copy; DMINT Copyright 2025. All Rights Reserved.
</footer> -->